// Pure breadcrumb resolver. Given a location and optional context labels,
// returns the trailing breadcrumb segments rendered on the right side of
// the SiteHeader. Empty array means "no breadcrumb".
//
// Each crumb may have an `href`. Crumbs without href render as plain text;
// the last (current-page) crumb is intentionally left without href.

const ROUTE_PATTERNS = [
  { match: /^\/n\/([^/]+)$/, kind: 'region' },
  { match: /^\/r\/([^/]+)$/, kind: 'region-geohash' },
  { match: /^\/a\/([^/]+)\/near\/([^/]+)$/, kind: 'aircraft' },
  { match: /^\/a\/([^/]+)$/, kind: 'aircraft-solo' },
  { match: /^\/e\/([^/]+)$/, kind: 'event' },
];

export function resolveBreadcrumb(location, ctx = {}) {
  const path = location?.pathname ?? '';
  for (const pattern of ROUTE_PATTERNS) {
    const m = path.match(pattern.match);
    if (!m) continue;
    if (pattern.kind === 'region') {
      return [{ label: ctx.regionName ?? m[1] }];
    }
    if (pattern.kind === 'region-geohash') {
      return [{ label: ctx.regionName ?? m[1] }];
    }
    if (pattern.kind === 'aircraft') {
      const region = {
        label: ctx.regionName ?? m[2],
        href: ctx.regionHref ?? `/r/${m[2]}`,
      };
      const aircraft = { label: ctx.aircraftLabel ?? m[1] };
      return [region, aircraft];
    }
    if (pattern.kind === 'aircraft-solo') {
      return [{ label: ctx.aircraftLabel ?? m[1] }];
    }
    if (pattern.kind === 'event') {
      const out = [];
      if (ctx.regionName) {
        out.push({ label: ctx.regionName, href: ctx.regionHref });
      }
      if (ctx.aircraftLabel) {
        out.push({ label: ctx.aircraftLabel, href: ctx.aircraftHref });
      }
      if (ctx.eventDateLabel) out.push({ label: ctx.eventDateLabel });
      return out;
    }
  }
  return [];
}
